import styled from 'styled-components';
import { Button } from 'semantic-ui-react';

export const VerificationErrorContainer = styled.div`
  border-radius: 10px;
  box-shadow: 0px 4px 4px 2px rgba(0, 0, 0, 0.25);
  margin: 72px 15px 15px;
  max-width: 620px;
  padding: 35px 50px;
  text-align: center;

  @media only screen and (max-width: 767px) {
    margin: 30px 15px 15px;
  }
`;

export const TitleText = styled.div`
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  margin: 25px 0;
`;

export const SubTitleText = styled.div`
  font-size: 24px;
  font-weight: 700;
  line-height: 23px;
  margin: 15px 0px 25px;
`;
export const IconContainer = styled.div`
  font-size: 20px;
  font-weight: 400;

  .status-icon-animation-enter {
    transform: rotateY(-90deg);
  }
  .status-icon-animation-enter-active {
    transform: rotateY(0);
    transition: transform 1500ms;
  }
`;

export const DescriptionText = styled.div`
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  margin: 30px 0px 35px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  font-size: 16px;
  font-weight: 500;
  justify-content: center;
`;

export const ButtonAction = styled.div`
  align-items: center;
  background-color: #a761a9;
  border: 2px solid #a761a9;
  border-radius: 8px;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  height: 35px;
  justify-content: center;
  transition: all 0.3s;
  width: 130px;

  &:hover {
    background-color: #fff;
    color: #a761a9;
    cursor: pointer;
    transition: all 0.3s;
  }
`;
